import { Icon, IconName } from '@blueprintjs/core';
import cn from 'classnames';

interface PageChangeButtonProps {
  disabled: boolean;
  direction: 'left' | 'right';
  onClick?(): void;
}

const PageChangeButton = ({ disabled, direction, onClick }: PageChangeButtonProps) => {
  return (
    <Icon
      className={cn('fs-5 ml-4 mr-4 bo-transparent', {
        'cursor-pointer': !disabled,
        gray3: disabled,
      })}
      iconSize={18}
      icon={`chevron-${direction}` as IconName}
      onClick={onClick}
    />
  );
};

export default PageChangeButton;
